import { Select, Space, Table } from "antd";
import { AnyObject } from "antd/es/_util/type";
import { ColumnsType, TableProps } from "antd/es/table";
import { ReactNode } from "react";
import SelectDownIcon from "../../assets/icons/SelectDownIcon";
import { addZeroIfInRange } from "../../utils/number";
import { selectSearchOption, selectStringOption } from "../../utils/utils";
import CustomPagination from "./CustomPagination";

interface CustomTableProps<T> extends TableProps<any> {
  page?: number;
  limit?: number;
  total?: number;
  columns: ColumnsType<T>;
  filterSection?: ReactNode;
  hideRowSelect?: boolean;
  hidePagination?: boolean;
  hideDifferentRowColor?: boolean;
  rootClassName?: string;
  handlePagination?: (paginationPage: number, paginationLimit: number) => void;
  handleLimit?: (val: number) => void;
  topSectionClassName?: string;
  leftFilterSection?: ReactNode;
}

const CustomTable = <T extends AnyObject>({
  loading,
  page,
  limit,
  total,
  dataSource,
  columns,
  filterSection,
  hideRowSelect,
  hidePagination,
  hideDifferentRowColor,
  className = "",
  rootClassName = "",
  handleLimit,
  handlePagination,
  topSectionClassName,
  leftFilterSection,
  ...rest
}: CustomTableProps<T>) => {
  const isShowTopSection = (!hideRowSelect && total) || filterSection;
  const isShowPagination =
    !hidePagination && dataSource?.length && total && limit;

  return (
    <div
      className={`border border-light rounded bg-white small-input-section ${rootClassName}`}
    >
      {isShowTopSection && (
        <Space
          wrap
          className={`p-4 justify-between w-full border-b border-b-light ${topSectionClassName}`}
        >
          {!hideRowSelect && (
            <Space wrap size={10}>
              <div className="flex items-center gap-2.5 text-body text-sm font-semibold">
                {/* <span>Total Rows</span> */}
                <span>Per Page</span>
                <Select
                  size="small"
                  showSearch
                  value={limit}
                  onChange={handleLimit}
                  filterOption={selectSearchOption}
                  options={selectStringOption(
                    ["10", "20", "50", "100", "1000"],
                    "number"
                  )}
                  className="min-w-[70px]"
                  suffixIcon={<SelectDownIcon />}
                />
                <span>of {addZeroIfInRange(total || 0)}</span>
              </div>
              {leftFilterSection}
            </Space>
          )}

          {filterSection ? (
            <Space wrap size={10}>
              {filterSection}
            </Space>
          ) : null}
        </Space>
      )}

      {/* Ant Design Table */}
      <Table
        loading={loading}
        columns={columns}
        pagination={false}
        dataSource={dataSource}
        className={`custom-table custom-scrollbar ${className} ${
          !hideDifferentRowColor && dataSource?.length
            ? "different-row-color"
            : ""
        } ${!isShowTopSection ? "table-rounded-top" : ""} ${
          !isShowPagination ? "table-hide-border-bottom" : ""
        }`}
        {...rest}
      />

      {isShowPagination ? (
        <CustomPagination
          total={total}
          limit={limit}
          page={page}
          hidePagination={hidePagination}
          handlePagination={handlePagination}
        />
      ) : null}
    </div>
  );
};

export default CustomTable;
